import React, { useCallback, useEffect, useRef } from 'react';
import ModalCommon from 'components/Input/ModalCommon';
import Button from 'components/Button';
import Spin from 'antd/lib/spin';
import { useState } from 'react';
import { toolbarOptions3 } from 'assets/sheets/images';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';
import Editor from 'components/Editor/Editor';

const NotePopup = ({ isOpen, onCancel, noteId, onSuccess }) => {
  const noteRef = useRef(null)
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    notes: '',
  });
  const [resetKey, setResetKey] = useState(0);

  const handleAfterOpen = useCallback(() => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      modalBody.scrollTop = 0;
    }
  }, []);

    const getInfoUser = () => {
    setLoading(true);
    CourseScheduleRegistationServices.getInfo(noteId)
      .then((res) => {
        setForm({
          notes : res.data.notes
        });
        setResetKey((k) => k + 1); // Reset editor after data is loaded
      })
      .catch((err) => toast.error(err?.message || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isOpen && noteId) {
      getInfoUser();
    } else if (!isOpen) {
      // Clear form when modal closes
      setForm({ notes: '' });
    }
  }, [isOpen, noteId]);

  const updateNote = () => {
    setLoading(true);
    CourseScheduleRegistationServices.updateCourseRegistration(noteId, {
      notes: (form.notes),
    })
      .then((res) => {
        if (res.data) {
          onSuccess(); // This should trigger parent to refetch data
          onCancel();
        }
      })
      .catch((err) => {
        toast.error(err.message || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  };

  const handleChangeData = ({ label, value }) => {
    setForm({
      ...form,
      [label]: value,
    });
  };

  const handleSave = () => {
    updateNote();
  };

  const handleCancel = () => {
    noteRef.current?.reset();
    onCancel();
  };

  return (
    <ModalCommon
      width={600}
      onAfterOpen={handleAfterOpen}
      title={'備考'}
      loading={loading}
      open={isOpen}
      padding={[24, 24, 10, 24]}
      onCancel={handleCancel}
      heightHeader={56}
      footer={
        <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
          <Button
            btnType="back"
            onClick={handleCancel}
            fontSize={14}
            height={40}
            width={120}
            className="border border-[#E6EBF1] bg-transparent text-[#595959]"
          >
            キャンセル
          </Button>
          <Button
            btnType="primary"
            onClick={handleSave}
            height={40}
            width={120}
            fontSize={14}
            className="border border-[#E6EBF1] bg-transparent text-[#595959]"
          >
            <p style={{ letterSpacing: '0' }}></p>保存
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <Editor
          ref={noteRef}
          label={'備考'}
          title="notes"
          alignLabel="center"
          widthLabel={142}
          options={[toolbarOptions3]}
          widthEditor={399}
          heightEditor={200}
          resetKey={resetKey}
          value={form.notes}
          onChange={handleChangeData}
        />
      </Spin>
    </ModalCommon>
  );
};

export default NotePopup;
